<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dSq7JG/tc-custom/9780226772981.jpg?1724818070484" alt="This image is the cover for the book Butcher's Moon, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Butcher's Moon, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>The sixteenth Parker novel, <i>Butcher’s Moon</i> is more than twice as long as most of the master heister’s adventures, and absolutely jammed with the action, violence, and nerve-jangling tension readers have come to expect. Back in the corrupt town where he lost his money, and nearly his life, in <i>Slayground</i>, Parker assembles a stunning cast of characters from throughout his career for one gigantic, blowout job: starting—and finishing—a gang war. It feels like the Parker novel to end all Parker novels, and for nearly twenty-five years that’s what it was. After its publication in 1974, Donald Westlake said, “Richard Stark proved to me that he had a life of his own by simply disappearing. He was gone.”<br/>  <br/> Featuring a new introduction by Westlake’s close friend and writing partner, Lawrence Block, this classic Parker adventure deserves a place of honor on any crime fan’s bookshelf. More than thirty-five years later, <i>Butcher’s Moon</i> still packs a punch: keep your calendar clear when you pick it up, because once you open it you won’t want to do anything but read until the last shot is fired.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark, Lawrence Block
      </h2>
      
      <p class="authorDescription body article"><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933–2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c06c4f0